"use client";

import { useSiteInfo } from "@context/siteInfoContext";
import type { Store } from "@server/gql/graphql";
import { useMemo } from "react";

type OpeningTime = {
  days: string[];
  closing: string;
  opening: string;
};

function getOpeningHours(store: Store): OpeningTime[] {
  if (!store.openingHoursCollection?.items?.length) return [];
  const { items = [] } = store.openingHoursCollection;
  const output: (OpeningTime | null)[] = [];
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (item) {
      const {
        dayOfTheWeek = "",
        closingTime = "",
        openingTime = "",
        closed,
      } = item;
      const ref = output.at(-1);
      if (ref) {
        if (ref.closing === closingTime && ref.opening && openingTime) {
          output.at(-1)?.days.push(dayOfTheWeek as string);
        } else if (!closed) {
          output.push({
            days: [dayOfTheWeek as string],
            closing: closingTime as string,
            opening: openingTime as string,
          });
        } else {
          output.push(null);
        }
      } else if (!closed) {
        output.push({
          days: [dayOfTheWeek as string],
          closing: closingTime as string,
          opening: openingTime as string,
        });
      } else {
        output.push(null);
      }
    } else {
      output.push(null);
    }
  }
  return output.filter(Boolean) as OpeningTime[];
}

export default function StoreInfo(props: { store: Store }) {
  const { dictionary: globalDictionary } = useSiteInfo();
  const { store } = props;
  const openingHours = useMemo(() => getOpeningHours(store), [store]);
  return (
    <div className="text-base space-y-4">
      <div className="flex flex-col">
        <h3 className="font-normal uppercase">{store?.title}</h3>
        {store?.email && (
          <a className="hover:underline" href={`mailto:${store.email}`}>
            {store.email}
          </a>
        )}
        {store?.phoneNumber && (
          <a
            className="hover:underline"
            href={`tel:${store.phoneNumber.replace(/\s/g, "")}`}
          >
            {store.phoneNumber}
          </a>
        )}
      </div>
      {openingHours?.length > 0 ? (
        <div>
          <h3 className="font-normal uppercase">
            {globalDictionary?.openingHours}
          </h3>
          {openingHours.map((item) => (
            <p key={item.days.at(0)}>
              {item.days.at(0)}&nbsp;-&nbsp;{item.days.at(-1)}
              :&nbsp;
              {item.opening}&nbsp;-&nbsp;{item.closing}
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
}
